
$(document).ready(function(){

  //Toggle Menu
  $('.toggle_menu').click(function(e){
    e.preventDefault();
    $('#site_menu, #menu_mask, .menu_icon').toggleClass('open');
  });

  $( '.animate-in:in-viewport' ).addClass( 'visible' );

  //Randomize sizes on thumbs
  var $sizes = ['block-size-small','block-size-medium','block-size-large'];
  $('.member').each(function(){
    var $size = $sizes[Math.floor(Math.random()*$sizes.length)];
    $(this).addClass($size);
  });

  //Click Thumbnails to Scroll
  $('.product_swiper_thumbnails li').click(function(){
    var $index = $(this).index();
    var $target = $('.product_images_desktop img').eq($index);
    $('html').animate(
      {
        scrollTop: $target.offset().top - 100,
      },
      500 //speed
    );
  })

  //Product Images
  const swiper = new Swiper('.product_images .swiper-container', {
    loop: true,
    autoHeight: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    on: {
      slideChangeTransitionStart: function(){
        var $index = $('.product_images .swiper-slide-active').attr('data-swiper-slide-index');
        $('.product_mob_swiper_thumbnails li').eq($index).addClass('active').siblings().removeClass('active');
      }
    }
  });
  $('.product_mob_swiper_thumbnails li').click(function(){
    var $index = $(this).index() + 1;
    swiper.slideTo($index);
  })

  //Thumbnail Swiper Images
  const thumbsswiper = new Swiper('.thumbnail_carousel .swiper-container', {
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false
    },
    slidesPerView: 2,
    breakpoints: {
      510: {
        slidesPerView: 4,
      },
      1200: {
        slidesPerView: 7,
      }
    }
  });
  
});

//Scroll Events
$(window).scroll(function(){
  //Animate in
  $( '.animate-in:in-viewport' ).addClass( 'visible' );


})

